
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.912.5c.422 0 .827.169 1.124.469.297.3.464.706.464 1.128v11.806c0 .422-.167.828-.464 1.128-.297.3-.702.469-1.124.469H3.088c-.422 0-.827-.169-1.124-.469a1.604 1.604 0 01-.464-1.128V2.097c0-.422.167-.828.464-1.128C2.261.669 2.666.5 3.088.5h9.824zm-.026 1.125H3.114a.5.5 0 00-.5.5v11.75a.5.5 0 00.5.5h9.772a.5.5 0 00.5-.5V2.125a.5.5 0 00-.5-.5zm-3.84 6.896a2.504 2.504 0 012.504 2.505.55.55 0 01-1.1 0c0-.73-.557-1.33-1.27-1.398l-.134-.007H6.954c-.775 0-1.404.63-1.404 1.405a.55.55 0 01-1.1 0 2.504 2.504 0 012.34-2.5l.164-.005h2.092zM8 3.5a2.143 2.143 0 110 4.286A2.143 2.143 0 018 3.5zm0 1.1a1.043 1.043 0 100 2.086A1.043 1.043 0 008 4.6z"}})])
          )
        }
      }
    